<div class="layout-column custom-panel full-width full-height">

  <div class="layout-row layout-align-start-center padding-top-10 padding-left-10 padding-right-10 padding-bottom-5">
    <app-bringoz-search-input class="flex"
                              [placeholder]="ngPlaceholder"
                              [query]="queryString"
                              (queryChangeEvent)="onQueryChange($event)">
    </app-bringoz-search-input>
  </div>

  <hr class="main-divider">

  <div class="flex layout-column padding-left-10 padding-right-10">
    <cdk-virtual-scroll-viewport [itemSize]="25" class="flex viewport" (scroll)="getNextBatch()">
      <div *cdkVirtualFor="let servicePoint of servicePoints"
           layout="column"
           class="item">

        <div class="flex layout-row layout-align-start-center pointer gap-5"
             (click)="onToggle(servicePoint)">
          <input type="radio"
                 name="servicePointOption"
                 [checked]="selectedServicePoint?.id ? servicePoint.id === selectedServicePoint.id : false">
          <span class="flex br-body-2 font-weight-400 text-ellipsis">{{ getListLabel(servicePoint) }}</span>
        </div>

      </div>
    </cdk-virtual-scroll-viewport>
  </div>

  <app-bringoz-linear-progress *ngIf="!!isLoading"></app-bringoz-linear-progress>

  <hr class="main-divider">

  <div class="layout-row layout-align-start-center justify-content-between padding-5">
    <bringoz-button [type]="'outline'"
                    [size]="buttonSize"
                    [theme]="'primary'"
                    (onClick)="onReset();$event.stopPropagation();">
      <span translate>Reset</span>
    </bringoz-button>
    <bringoz-button [theme]="'secondary'"
                    [size]="buttonSize"
                    [isDisabled]="!selectedServicePoint"
                    (onClick)="onSubmit();$event.stopPropagation();">
      <span translate>Submit</span>
    </bringoz-button>
  </div>

</div>
